import axios from 'axios'

const API_URL = 'https://api.padmoney.com/v2/cep'

const http = axios.create({
  baseURL: API_URL,
  validateStatus: () => true
})

async function helper(cep) {
  try {
    return await http.get(cep)
  } catch (ignore) {
    return { data: {} }
  }
}

export default async function (cep) {
  const { data } = await helper(cep)

  return data
}
